import React from 'react';
import Dashboard from '../../layout/Dashboard';
import BusinessForm from '../../components/forms/BusinessForm';

const BusinessAdd = ({history}) => {
  const empresa = {
    nomeFantasia: '',
    razaoSocial: '',
    cnpj: '',
    descritivo: '',
    postalCode: '',
    street: '',
    city: '',
    state: '',
    number: 0,
    // id: 1,
  };

  return (
    <Dashboard>
      <BusinessForm
        history={history}
        empresa={empresa}
        namePage={'Cadastrar Nova Empresa'}
      />
    </Dashboard>
  );
};

export default BusinessAdd;
